;(
	function () {
		const languages = document.querySelector( '.languages' );
		const activeClass = 'languages__language--active';

		if ( !languages ) {
			return;
		}

		const languageButtons = languages.querySelectorAll( '.languages__language' );

		languages.addEventListener( 'click', e => {
			e.preventDefault();
			languageButtons.forEach( elem => {
				elem.classList.remove( activeClass );
			} );
			e.target.parentElement.classList.add( activeClass );
		} );
	}()
);
